/* eslint-disable camelcase */
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import get from "lodash/get";
import CollectionTitle from "../../atoms/CollectionTitle";
import { RowSeparator } from "../../atoms/RowSeparator";
import ShowMoreButton from "../../atoms/ShowMoreButton";
import { generateNavigateSlug, navigateTo } from "../../utils";
import { DfpComponent } from "../../ads/dfp-component";
import StoryCard from "./StoryCard";

import "./four-column-ten-stories.m.css";

export function FourColumnTenStories({ config = {}, collection, stories, extraProp = "" }) {
  const {
    enable_sponsor_ad,
    show_column_separator,
    show_row_separator,
    show_story_separator,
    show_read_time,
    show_row_title,
    show_timestamp,
    sponsor_ad_details,
    show_sub_headline,
    show_more_stories,
    show_row_ad_unit_bottom,
  } = get(collection, ["associated-metadata"], {});

  const dispatch = useDispatch();
  const qtConfig = useSelector((state) => get(state, ["qt", "config"], {}));
  const url = generateNavigateSlug(collection, qtConfig);
  const sponsorAdConfig = useSelector((state) => get(state, ["qt", "config", "ads-config", "slots", "sponsor_ad"], {}));

  const rowAdBottom = show_row_ad_unit_bottom?.split("/").slice(-1)[0];
  const rowAdBottomDivId = useSelector((state) =>
    get(state, ["qt", "config", "ads-config", "ad_div_mapping", rowAdBottom], "")
  );

  const pageType = useSelector((state) => get(state, ["qt", "pageType"], null));

  const [firstStory, ...restOfStories] = stories;
  const sectionSlug = extraProp;
  if (!firstStory) return null;
  return (
    <>
      <div className="row-component" styleName="four-column-ten-stories">
        {show_row_title && (
          <CollectionTitle
            collection={collection}
            enableSponsorAd={enable_sponsor_ad}
            sponsorAdDetails={sponsor_ad_details}
            sectionSlug={sectionSlug}
            sponsorAdConfig={sponsorAdConfig}
          />
        )}
        <div
          styleName={`story-list ${show_column_separator ? "column-separator" : ""} ${
            show_story_separator ? "story-separator" : ""
          }`}
        >
          <StoryCard
            story={firstStory}
            showTimeStamp={show_timestamp}
            showReadTime={show_read_time}
            showSubHeadline={show_sub_headline}
            index={0}
            sectionSlug={sectionSlug}
          />
          {!!restOfStories.length &&
            restOfStories.map((story, index) => (
              <StoryCard
                key={story.id}
                story={story}
                showTimeStamp={show_timestamp}
                showReadTime={show_read_time}
                showSubHeadline={false}
                index={index + 1}
                sectionSlug={sectionSlug}
              />
            ))}
        </div>
        {show_more_stories && (
          <ShowMoreButton
            collection={collection}
            config={config}
            navigate={() => navigateTo(dispatch, url)}
            qtConfig={qtConfig}
          />
        )}
      </div>
      <div styleName="separator-container">{show_row_separator && <RowSeparator />}</div>
      {show_row_ad_unit_bottom && <DfpComponent adStyleName="ad-slot-size-300x250" id={rowAdBottomDivId} />}
    </>
  );
}

FourColumnTenStories.propTypes = {
  config: PropTypes.object,
  collection: PropTypes.object.isRequired,
  stories: PropTypes.array.isRequired,
  extraProp: PropTypes.string,
};

FourColumnTenStories.storyLimit = 10;
